export default __webpack_public_path__ + "static/filedblob-247cc16436282990e4fa2f6f58068996.png";